export const SET_INITIAL_STATE = "SET_INITIAL_STATE";
export const SET_PAGE_SIZE_GLOBAL = " SET_PAGE_SIZE_GLOBAL"

//-------------------------------RETURN_REQUESTS-LIST------------------------------------------
export const SET_RETURN_REQUESTS_PENDING = "SET_RETURN_REQUESTS_PENDING";
export const SET_RETURN_REQUESTS_LIST = "SET_RETURN_REQUESTS_LIST";
export const SET_RETURN_REQUESTS_LIST_COUNT = " SET_RETURN_REQUESTS_LIST_COUNT"
export const SET_RETURN_REQUESTS_FORM = " SET_RETURN_REQUESTS_FORM"
export const RETURN_REQUESTS_LIST_ERROR = " RETURN_REQUESTS_LIST_ERROR"
export const RETURN_REQUESTS_LIST_COUNT_ERROR = " RETURN_REQUESTS_LIST_COUNT_ERROR"

//-------------------------------RETURN_REQUESTS-ACTIONS---------------------------------------
export const OPEN_RETURN_REQUESTS_ACTION_MODAL = "OPEN_RETURN_REQUESTS_ACTION_MODAL";
export const CLOSE_RETURN_REQUESTS_ACTION_MODAL = "CLOSE_RETURN_REQUESTS_ACTION_MODAL";
export const SUBMIT_RETURN_REQUESTS_ACTION_PENDING = "SUBMIT_RETURN_REQUESTS_ACTION_PENDING";
export const SUBMIT_RETURN_REQUESTS_ACTION_SUCCESS = "SUBMIT_RETURN_REQUESTS_ACTION_SUCCESS";
export const SUBMIT_RETURN_REQUESTS_ACTION_ERROR = "SUBMIT_RETURN_REQUESTS_ACTION_ERROR";
export const CLEAR_SUBMIT_RETURN_REQUESTS_ACTION_ERROR = "CLEAR_SUBMIT_RETURN_REQUESTS_ACTION_ERROR";